import { currencies } from './currencies';
import { type SupportedCurrencies } from './currencies';

const abbreviatedCurrencies = ['CAD', 'AUD', 'CHF', 'MXN'] as const;
type AbbreviatedCurrencies = (typeof abbreviatedCurrencies)[number];

type AbbrCurrenciesType = Record<AbbreviatedCurrencies, string>;

export type FlagLinks = {
    sm: Record<string, string>;
    md: Record<string, string>;
};

type CurrencyConstants = {
    currencies: Record<string, string>;
    symbols: Record<SupportedCurrencies, string>;
    abbreviations: Record<string, string>;
    flags: FlagLinks;
};

const abbreviations = abbreviatedCurrencies.reduce<Partial<AbbrCurrenciesType>>((acc, curr) => {
    if (!acc[curr]) {
        acc[curr] = curr;
    }
    return acc;
}, {});

export const currencyConstants: CurrencyConstants = {
    currencies: {},
    symbols: {
        GBP: '£',
        EUR: '€',
        USD: '$',
        CAD: '$',
        AUD: '$',
        CHF: '', // Swiss francs don't have a currency symbol
        MXN: '$',
        NOK: 'kr.',
        SEK: 'kr.',
        DKK: 'kr.',
    },
    abbreviations,
    flags: { sm: {}, md: {} },
};

(currencies || []).forEach((currency: string) => {
    currencyConstants.flags.sm[currency] =
        'https://a.1stdibscdn.com/assets/currency-flags/1x/flag_' + currency.toLowerCase() + '.png';
    currencyConstants.flags.md[currency] =
        'https://a.1stdibscdn.com/assets/currency-flags/2x/flag_' + currency.toLowerCase() + '.png';
});

currencies.forEach((currency: string) => {
    currencyConstants.currencies['CURRENCY_' + currency] = currency;
});
